import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'

export const getDashboardData = createAsyncThunk('dashboard/getDashboardData', async () => {
  try {
    let url = '/dashboard/count'
    const response = await apiClient.get(url)
    return response.data.result
  } catch (error) {
    console.error('builder function error:', error)
    throw error
  }
})
